import Tabs from "@/components/Tabs";
import { Path, useNavigate } from "@/router";
import { useLocation, useParams } from "react-router-dom";
import { useSectionOperationsAccess } from "../useSectionOperationsAccess";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const { sectionId } = useParams();
  const location = useLocation();
  const { pathname } = location;
  const currentUrl = pathname.replace(/\/$/, "");
  const navigate = useNavigate();
  const { ready, showCommittees, showSectionOfficeFacilityTabs, showGovernance, showNotifications } =
    useSectionOperationsAccess(sectionId);

  if (!sectionId || !ready) return null;

  const tabItems = [
    showCommittees && {
      label: "Committees",
      to: "/sections/:sectionId/operations/committees" as Path,
      active:
        currentUrl === `/sections/${sectionId}/operations/committees` ||
        currentUrl.startsWith(`/sections/${sectionId}/operations/committees/`)
    },
    showSectionOfficeFacilityTabs && {
      label: "Employees",
      to: "/sections/:sectionId/operations/employees" as Path,
      active: currentUrl === `/sections/${sectionId}/operations/employees`
    },
    showGovernance && {
      label: "Governance",
      to: "/sections/:sectionId/operations/governance" as Path,
      active: currentUrl === `/sections/${sectionId}/operations/governance`
    },
    showSectionOfficeFacilityTabs && {
      label: "Contact",
      to: "/sections/:sectionId/operations/contact" as Path,
      active: currentUrl === `/sections/${sectionId}/operations/contact`
    },
    showNotifications && {
      label: "Notifications",
      to: "/sections/:sectionId/operations/notifications" as Path,
      active: currentUrl === `/sections/${sectionId}/operations/notifications`
    }
  ].filter(Boolean) as { label: string; to: Path; active: boolean }[];

  return (
    <>
      <Tabs
        tabItems={tabItems.map(({ label, to, active }) => ({
          label,
          onClick: () => navigate(to, { params: { sectionId } }),
          active
        }))}
      />
      <div className="flex flex-col" data-testid="tab-content">
        {children}
      </div>
    </>
  );
}
